import { DraftQuestionnaireEntry } from '../../../data/model/questionnaire'
import {
  MarketVisibilityFilter,
  visibleInAllMarkets
} from '../../Questionnaire/MarketVisibility/marketVisibility'
import { CustomAudienceTranslationGroup } from './extractAudienceFields'
import { extractAllSurveyFields } from './extractTranslatableFields'

export interface CompletionStats {
  total: number
  translated: number
  pct: number
}

export const computeCompletion = (
  entries: ReadonlyArray<DraftQuestionnaireEntry>,
  languageCode: string,
  audienceGroups: ReadonlyArray<CustomAudienceTranslationGroup> = [],
  // Options / rows only — whole entries are dropped by the caller's traversal.
  isVisible: MarketVisibilityFilter = visibleInAllMarkets
): CompletionStats => {
  let total = 0
  let translated = 0
  // Fields whose master text is empty (e.g. a text card with no subtitle or
  // body) are skipped entirely — they have nothing to translate. Counting
  // them would inflate the denominator and make completion unreachable:
  // auto-translate never emits a translation for an empty master, so such a
  // field would stay "untranslated" forever and a launch gate keyed off
  // `translated < total` could never clear. Keeping the source of truth here
  // also keeps the sidebar's percentage honest.
  extractAllSurveyFields(entries, isVisible).forEach((field) => {
    if (!field.master.trim()) return
    // Only count fields that gate launch — see block comment above.
    if (!field.countsTowardCompletion) return
    total += 1
    if (field.getCurrent(languageCode).trim().length > 0) {
      translated += 1
    }
  })
  audienceGroups.forEach((group) => {
    group.fields.forEach((field) => {
      if (!field.master.trim()) return
      // Audience fields always count toward completion.
      if (!field.countsTowardCompletion) return
      total += 1
      if (field.getCurrent(languageCode).trim().length > 0) {
        translated += 1
      }
    })
  })
  const pct = total === 0 ? 100 : Math.round((translated / total) * 100)
  return { total, translated, pct }
}
